import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { AdminApp } from './admin/AdminApp';
import { LanguageProvider } from './i18n';
import './styles.css';

const isAdminRoute = window.location.pathname.startsWith('/admin');
createRoot(document.getElementById('root')!).render(<LanguageProvider>{isAdminRoute ? <AdminApp /> : <App />}</LanguageProvider>);
